import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.nutritionInformation.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.nutritionInformation.fields.name'),
  },
  {
    name: 'servingsNumber',
    label: i18n('entities.nutritionInformation.fields.servingsNumber'),
  },
  {
    name: 'labelFormat',
    label: i18n('entities.nutritionInformation.fields.labelFormat'),
  },
  {
    name: 'servingQuantityUnit',
    label: i18n('entities.nutritionInformation.fields.servingQuantityUnit'),
  },
  {
    name: 'servingSizeWeight',
    label: i18n('entities.nutritionInformation.fields.servingSizeWeight'),
  },
  {
    name: 'servingSizeUnit',
    label: i18n('entities.nutritionInformation.fields.servingSizeUnit'),
  },
  {
    name: 'calories',
    label: i18n('entities.nutritionInformation.fields.calories'),
  },
  {
    name: 'totalFat',
    label: i18n('entities.nutritionInformation.fields.totalFat'),
  },
  {
    name: 'saturatedFat',
    label: i18n('entities.nutritionInformation.fields.saturatedFat'),
  },
  {
    name: 'transFat',
    label: i18n('entities.nutritionInformation.fields.transFat'),
  },
  {
    name: 'polyunsaturatedFat',
    label: i18n('entities.nutritionInformation.fields.polyunsaturatedFat'),
  },
  {
    name: 'monounsaturatedFat',
    label: i18n('entities.nutritionInformation.fields.monounsaturatedFat'),
  },
  {
    name: 'cholesterol',
    label: i18n('entities.nutritionInformation.fields.cholesterol'),
  },
  {
    name: 'salt',
    label: i18n('entities.nutritionInformation.fields.salt'),
  },
  {
    name: 'totalCarbohydrates',
    label: i18n('entities.nutritionInformation.fields.totalCarbohydrates'),
  },
  {
    name: 'dietaryFiber',
    label: i18n('entities.nutritionInformation.fields.dietaryFiber'),
  },
  {
    name: 'sugars',
    label: i18n('entities.nutritionInformation.fields.sugars'),
  },
  {
    name: 'addedSugars',
    label: i18n('entities.nutritionInformation.fields.addedSugars'),
  },
  {
    name: 'sugarAlcohol',
    label: i18n('entities.nutritionInformation.fields.sugarAlcohol'),
  },
  {
    name: 'protein',
    label: i18n('entities.nutritionInformation.fields.protein'),
  },
  {
    name: 'energy',
    label: i18n('entities.nutritionInformation.fields.energy'),
  },
  {
    name: 'vitaminDataFormat',
    label: i18n('entities.nutritionInformation.fields.vitaminDataFormat'),
  },
  {
    name: 'calcium',
    label: i18n('entities.nutritionInformation.fields.calcium'),
  },
  {
    name: 'iron',
    label: i18n('entities.nutritionInformation.fields.iron'),
  },
  {
    name: 'vitaminD',
    label: i18n('entities.nutritionInformation.fields.vitaminD'),
  },
  {
    name: 'potassium',
    label: i18n('entities.nutritionInformation.fields.potassium'),
  },
  {
    name: 'vitaminA',
    label: i18n('entities.nutritionInformation.fields.vitaminA'),
  },
  {
    name: 'vitaminC',
    label: i18n('entities.nutritionInformation.fields.vitaminC'),
  },
  {
    name: 'vitaminE',
    label: i18n('entities.nutritionInformation.fields.vitaminE'),
  },
  {
    name: 'vitaminK',
    label: i18n('entities.nutritionInformation.fields.vitaminK'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.nutritionInformation.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.nutritionInformation.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
